const feedback = [
    {
        path: '/feedback/manage',
        name: 'feedbackManage',
        component: () => import('@/view/feedback/manage'),
    },
]
export default feedback